import React, { memo, useCallback } from "react";

import { Style, StyledTextarea } from "..";

const TextareaBase: React.FC<Textarea.Props> = ({
	disableInteractions = false,
	onCopy,
	onCut,
	onPaste,
	onDragStart,
	onDrop,

	...props
}) => {
	const handleCopy = useCallback(
		(e: React.ClipboardEvent<HTMLTextAreaElement>) => {
			if (disableInteractions) e.preventDefault();
			onCopy && onCopy(e);
		},
		[disableInteractions, onCopy],
	);

	const handleCut = useCallback(
		(e: React.ClipboardEvent<HTMLTextAreaElement>) => {
			if (disableInteractions) e.preventDefault();
			onCut && onCut(e);
		},
		[disableInteractions, onCut],
	);

	const handlePaste = useCallback(
		(e: React.ClipboardEvent<HTMLTextAreaElement>) => {
			if (disableInteractions) e.preventDefault();
			onPaste && onPaste(e);
		},
		[disableInteractions, onPaste],
	);

	const handleDragStart = useCallback(
		(e: React.DragEvent<HTMLTextAreaElement>) => {
			if (disableInteractions) e.preventDefault();
			onDragStart && onDragStart(e);
		},
		[disableInteractions, onDragStart],
	);

	const handleDrop = useCallback(
		(e: React.DragEvent<HTMLTextAreaElement>) => {
			if (disableInteractions) e.preventDefault();
			onDrop && onDrop(e);
		},
		[disableInteractions, onDrop],
	);

	return (
		<StyledTextarea
			{...props}
			onCopy={handleCopy}
			onCut={handleCut}
			onPaste={handlePaste}
			onDragStart={handleDragStart}
			onDrop={handleDrop}
		/>
	);
};

export const Textarea = memo(TextareaBase);

declare namespace Textarea {
	interface Props
		extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
			Style.TextareaType {
		disableInteractions?: boolean;
	}
}

export default TextareaBase;
